function returnMarkupTX({
  Name,
  Address,
  Website,
  Phone,
  Moderna,
  Pfizer,
  UpdateTime,
  UpdateDate
}) {

function formatContactInfo(Phone, Website){

  var resultstring
  var link

  if(Website!==""){
    link=`${`<a href="${Website}" target="_blank">the website</a>.`}`
  }

  if(Phone!=="" && Website !==""){
    resultstring = "Contact this site at " + Phone + " or visit " + link
  }

  else if(Phone==="" && Website !==""){
    resultstring= "Visit " + link
  }

  else if (Phone!=="" && Website===""){
    resultstring = "Contact this site at " + Phone + "."
  }

  else if (Phone==="" && Website===""){
    resultstring=""
  }

  return resultstring

}

function formatVaccineString(Moderna, Pfizer, UpdateDate, UpdateTime){
  var resultstring

  if((UpdateTime!=="" && UpdateDate!=="") || (UpdateTime==="" && UpdateDate!=="")){
    if(Moderna==="" && Pfizer ===""){
      resultstring=""
    }
    else if(Moderna!=="" && Pfizer !==""){
      resultstring="this site had " + Moderna.toLocaleString() + " doses of the Moderna vaccine and " + Pfizer.toLocaleString() + " doses of the Pfizer vaccine."
    }
    else if(Moderna==="" && Pfizer!==""){
      resultstring = "this site had " + Pfizer.toLocaleString() + " doses of the Pfizer vaccine."
    }

    else if(Moderna!=="" && Pfizer===""){
      resultstring = "this site had " + Moderna.toLocaleString() + " doses of the of Moderna vaccine."
    }
  }

  else{

    if(Moderna==="" && Pfizer ===""){
      resultstring=""
    }
    else if(Moderna!=="" && Pfizer !==""){
      resultstring="This site had " + Moderna.toLocaleString() + " doses of the Moderna vaccine and " + Pfizer.toLocaleString() + " doses of the Pfizer vaccine."
    }
    else if(Moderna==="" && Pfizer!==""){
      resultstring = "This site had " + Pfizer.toLocaleString() + " doses of the Pfizer vaccine."
    }

    else if(Moderna!=="" && Pfizer===""){
      resultstring = "This site had " + Moderna.toLocaleString() + " doses of the of Moderna vaccine."
    }

  }

  return resultstring

}

function formatLastUpdated(UpdateDate, UpdateTime){
  var resultstring
  if(UpdateTime!=="" && UpdateDate !==""){
    resultstring="As of " + UpdateDate + " at " + UpdateTime + ", "
  }
  else if (UpdateTime!=="" && UpdateDate ===""){
    resultstring=""
  }
  else if(UpdateTime==="" && UpdateDate !==""){
    resultstring="As of " + UpdateDate + ", "
  }
  else if(UpdateTime==="" && UpdateDate ===""){
    resultstring=""
  }
  return resultstring
}

const markup = `
    ${`<h3>${Name}</h3>`}
    ${`<p class="address">${Address}</p>`}
    ${`<p>${formatLastUpdated(UpdateDate, UpdateTime)} ${formatVaccineString(Moderna, Pfizer, UpdateDate, UpdateTime)}</p>`}
    ${`<p>${formatContactInfo(Phone, Website)}</p>`}
    `
  return markup
}

export { returnMarkupTX }